import React, { useState } from "react";
import { Building2 } from "lucide-react";
import GestionaleShell from "./GestionaleShell";
import GestCrudTable from "./GestCrudTable";

const FIELDS = [
  { key: "name", label: "Ragione sociale", type: "text", required: true, span: 2 },
  { key: "country", label: "Paese", type: "select", options: [
    { value: "IT", label: "Italia" }, { value: "FR", label: "Francia" }, { value: "ES", label: "Spagna" },
    { value: "PT", label: "Portogallo" }, { value: "DE", label: "Germania" }, { value: "AT", label: "Austria" },
    { value: "GR", label: "Grecia" }, { value: "EU", label: "Altro EU" },
  ], defaultValue: "IT" },
  { key: "vat", label: "Partita IVA", type: "text" },
  { key: "category", label: "Categoria", type: "select", options: [
    { value: "wine", label: "Vino" }, { value: "food", label: "Food" }, { value: "mixed", label: "Misto" },
  ], defaultValue: "wine" },
  { key: "incoterm", label: "Incoterm", type: "select", options: [
    { value: "EXW", label: "EXW" }, { value: "FOB", label: "FOB" }, { value: "CIF", label: "CIF" }, { value: "DDP", label: "DDP" },
  ], defaultValue: "EXW" },
  { key: "moq", label: "MOQ", type: "text", placeholder: "es. 600 bot / 1 pallet" },
  { key: "contact_person", label: "Referente", type: "text" },
  { key: "contact_email", label: "Email", type: "text" },
  { key: "contact_phone", label: "Telefono", type: "text" },
  { key: "status", label: "Stato", type: "select", statusTone: true, options: [
    { value: "draft", label: "Bozza", tone: "stone" },
    { value: "active", label: "Attivo", tone: "emerald" },
    { value: "suspended", label: "Sospeso", tone: "amber" },
    { value: "archived", label: "Archiviato", tone: "stone" },
  ], defaultValue: "draft" },
  { key: "notes", label: "Note", type: "textarea", hideInTable: true },
];

export default function SuppliersPage() {
  const [data, setData] = useState({ total: 0 });
  const active = (data?.items || []).filter(i => i.status === "active").length;

  return (
    <GestionaleShell
      icon={Building2}
      code="01"
      title="Supplier Onboarding"
      subtitle="Anagrafica fornitori europei: contratti, MOQ, Incoterm e workflow di attivazione."
      kpiBlocks={[
        { value: data.total || 0, label: "Fornitori totali" },
        { value: active, label: "Attivi" },
      ]}
    >
      <GestCrudTable
        endpoint="/gestionale/suppliers"
        fields={FIELDS}
        itemLabel="fornitore"
        emptyHint="Aggiungi i tuoi primi fornitori EU per attivare la pipeline."
        testIdPrefix="suppliers"
        onItemsLoaded={(d) => setData(d)}
      />
    </GestionaleShell>
  );
}
